const env = {};

window.Env && Object.assign(env, window.Env);
window.Env = env;

export { env };
